angular.module('gym.templates').directive('commsTabs', function() {
  return {
    restrict: 'E',
    transclude: true,
    template: require('templates/gyms/bulk_messages/comms_tabs.html.slim')
  };
});
